import { AgendaItem, AgendaItemType } from 'mini-agenda';

/**
 * Checks if agenda item is day header
 * @param item Agenda Iitem passed
 */
export default function isAgendaItemNotHeader(item: AgendaItem) {
    return !item || item.type !== AgendaItemType.DayMonthSeparator;
}
